import { TierBasedCategoryCoins } from '@zet/constants/tierBasedCategoryCoins'
import { H6, SH2, Stack } from '@zet/design-system'
import { useLoyaltyPayoutMeta } from '@zet/feature-loyalty'
import { useTier } from '@zet/feature-loyalty/api/hooks'
import { i18n } from '@zet/localization'

import ZetCoin from '../../assets/svg/zetCoin.svg'
import { getPayoutText } from '../../utils'
import {
  extraLoyaltyPayoutEligibleCategory,
  minBasePayoutToGetCoins,
} from '../../utils/constants'

const DetailPayoutWithCoins = ({
  commission,
  categoryId,
  partnerId,
}: {
  commission: string
  categoryId: string | number
  partnerId: string | number
}) => {
  const { data: getTier } = useTier()
  const extraCoins = TierBasedCategoryCoins?.[getTier?.cohort]?.[categoryId]
  const { loyaltyPayout, isPercentagePayout, extractedPayoutValue } =
    useLoyaltyPayoutMeta({
      partnerId,
      isUserCurrentTierPayout: true,
      payoutContent: commission,
    })

  const eligibleForCoins = isPercentagePayout
    ? true
    : extractedPayoutValue >= minBasePayoutToGetCoins
    ? true
    : false
  return (
    <Stack className="flex-row items-center">
      <H6 className="text-success-150">
        {commission || '₹0'}{' '}
        {getTier?.cohort === 'BEGINNER' ||
        !extraLoyaltyPayoutEligibleCategory.includes(categoryId?.toString())
          ? ''
          : ' + ' +
            getPayoutText(
              loyaltyPayout?.partnerDiscountType,
              loyaltyPayout?.payout
            )}
        {eligibleForCoins && extraCoins > 0 ? (
          <SH2 className="text-warning-200">{' + ' + extraCoins}</SH2>
        ) : (
          <></>
        )}
      </H6>
      {eligibleForCoins && extraCoins > 0 ? (
        <>
          <ZetCoin height={20} width={20} className="mx-[2]" />
          <SH2 className="text-warning-200">
            {i18n.t('payoutBreakoutLoyalty.zetCoins')}
          </SH2>
        </>
      ) : (
        <></>
      )}
    </Stack>
  )
}

export default DetailPayoutWithCoins
